import { render } from "./PrivacyTerms.vue?vue&type=template&id=2ac51f35"
const script = {}

import "./PrivacyTerms.vue?vue&type=style&index=0&id=2ac51f35&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__